import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddonIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 15.088H9v-2h2v-2h2v2h2v2h-2v2h-2v-2z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8.809 3.176 5.964 7.088h12.072l-2.845-3.912L16.81 2l3.7 5.088H23v2h-1.153l-2 12H4.153l-2-12H1v-2h2.49L7.192 2 8.81 3.176zm11.01 5.912H4.18l1.667 10h12.306l1.667-10z",
		clipRule: "evenodd"
	})]
});
export default SvgAddonIcon;
